import theme from "Theme";
const appStyles = {
  "@global": {
    "html,body": {
      height: "100%",
      fontFamily: theme.bodyFont,
      backgroundColor : theme.white,
      color : theme.marineBlue,
    }
  }
};

export default appStyles;



// WEBPACK FOOTER //
// ./src/components/AppContainer/App/app.style.js